import React, { memo } from 'react'

import {
  number,
  string,
  bool,
  shape,
} from 'prop-types'

import { TopSectionPropsProvider } from 'Pods/ItemPage/TopSection/context/TopSectionPropsContext'
import usePermissions from 'Pods/LazyLoaded/UseCaseAreaSidebar/hooks/usePermissions'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

import UseCasesArea from './Components/UseCasesArea/UseCasesArea'
import useItemUseCases from './Hooks/useItemUseCases'
import useUseCaseLikes from './Hooks/useUseCaseLikes'

const selectProduct = (config) => config?.product

function UseCasesAreaWrapper({
  useCasesAreaData,
  role,
  currentUsername = '',
  extractingCoreStyles,
  showUseCasesSection = false,
  showUseCasesFor3dModels = false,
}) {
  const product = usePageConfig({ select: selectProduct })
  const {
    useCases,
    loading: isLoadingUseCases,
    addUseCaseOptimistic,
    removeUseCaseOptimistic,
    updateUseCaseOptimistic,
  } = useItemUseCases()

  const { handleLike, handleUnlike } = useUseCaseLikes({
    useCases,
    onUpdate: updateUseCaseOptimistic,
  })

  const { canUseLikeFeature } = usePermissions({
    useCases,
    currentUsername,
  })

  const itemId = product?.id
  const canDownloadSlicerFile = product?.isPurchased || product?.freeItem

  if (extractingCoreStyles) {
    return (
      <div className="extraction-versions-wrapper">
        <TopSectionPropsProvider
          value={{
            is3dPrintModel: false,
            role: useCasesAreaData.role,
          }}
        >
          <UseCasesArea
            role={useCasesAreaData.role}
            useCases={[]}
            isLoading={false}
            numberOfUseCases={0}
            currentUsername=""
            onAdd={() => {}}
            onRemove={() => {}}
            onUpdate={() => {}}
            onLike={() => {}}
            onUnlike={() => {}}
            canUseLikeFeature={false}
            itemId={0}
            showUseCasesFor3dModels={showUseCasesFor3dModels}
          />
        </TopSectionPropsProvider>
        <TopSectionPropsProvider
          value={{
            is3dPrintModel: true,
            role: useCasesAreaData.role,
          }}
        >
          <UseCasesArea
            role={useCasesAreaData.role}
            isLoading
            numberOfUseCases={useCasesAreaData.itemUseCaseCount}
            useCases={useCasesAreaData.useCases}
            currentUsername=""
            onAdd={() => {}}
            onRemove={() => {}}
            onUpdate={() => {}}
            onLike={() => {}}
            onUnlike={() => {}}
            canUseLikeFeature={useCasesAreaData.canUseLikeFeature}
            itemId={useCasesAreaData.itemId}
            showUseCasesFor3dModels={showUseCasesFor3dModels}

          />
        </TopSectionPropsProvider>
      </div>
    )
  }

  if (!showUseCasesSection) {
    return null
  }

  return (
    <UseCasesArea
      role={role}
      useCases={useCases}
      numberOfUseCases={useCasesAreaData.itemUseCaseCount}
      isLoading={isLoadingUseCases}
      currentUsername={currentUsername}
      onAdd={addUseCaseOptimistic}
      onRemove={removeUseCaseOptimistic}
      onUpdate={updateUseCaseOptimistic}
      onLike={handleLike}
      onUnlike={handleUnlike}
      canUseLikeFeature={canUseLikeFeature}
      itemId={itemId}
      canDownloadSlicerFile={canDownloadSlicerFile}
      showUseCasesFor3dModels={showUseCasesFor3dModels}
    />
  )
}

UseCasesAreaWrapper.propTypes = {
  useCasesAreaData: shape({
    is3dPrintModel: bool,
    itemUseCaseCount: number.isRequired,
  }).isRequired,
  role: string.isRequired,
  currentUsername: string,
  extractingCoreStyles: bool.isRequired,
  showUseCasesSection: bool,
  showUseCasesFor3dModels: bool,
}

export default memo(UseCasesAreaWrapper)
